import Schaeffer from '../images/SchaefferFrancis.jpg';


function SchaefferFrancisEmbed(){
    return (
        <>
        <img src={Schaeffer} alt="Francis Schaeffer Portrait" className="faithImage" />
        </>
    );
};
export default SchaefferFrancisEmbed;